import * as Sentry from '@sentry/vue'
import isWebview from 'is-ua-webview'
import type { App } from 'vue'

export function setupSentry(app: App) {
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.MODE,
        tracesSampleRate: 1.0,
        logErrors: true,
        enabled: import.meta.env.MODE !== 'development',
        // debug: true,
        integrations: [Sentry.browserTracingIntegration()],
        beforeSend: (event) => {
            // prevent event on localhost
            if (window.location.hostname === 'localhost') {
                return null
            }

            return event
        },
    })
}

export function updateSentryContext(partyId: string, workflowDefinitionId: string) {
    Sentry.setUser({ id: partyId })
    Sentry.setTag('workflow_definition_id', workflowDefinitionId)
    Sentry.setTag('is_webview', isWebview(window.navigator.userAgent))
}
